'use strict';exports.__esModule = true;exports.PublishPropertyPage = undefined;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxConnect = require('redux-connect');
var _reduxPagan = require('redux-pagan');
var _reactScroll = require('react-scroll');
var _reactRouter = require('react-router');
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _containers = require('../../containers');
var _components = require('../../components');






var _ModalFeedbackIncreaseLimits = require('../../components/FeedbackIncreaseLimits/ModalFeedbackIncreaseLimits');var _ModalFeedbackIncreaseLimits2 = _interopRequireDefault(_ModalFeedbackIncreaseLimits);
var _RealtorLandingPublishFormModal = require('../../containers/RealtorLandingPublishForm/RealtorLandingPublishFormModal');var _RealtorLandingPublishFormModal2 = _interopRequireDefault(_RealtorLandingPublishFormModal);

var _messageModal = require('../../redux/modules/messageModal');
var _contactAgencyOnPropertyCreation = require('../../redux/modules/contactAgencyOnPropertyCreation');
var _manageProperties = require('../../redux/modules/manageProperties');






var _publishProperty = require('../../redux/modules/publishProperty');
var _payments = require('../../redux/modules/payments');
var _reportIssues = require('../../redux/modules/reportIssues');
var _userAuthentication = require('../../redux/modules/userAuthentication');

var _constants = require('../../constants');








var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _publishAnalytics = require('../../helpers/publishAnalytics');var _publishAnalytics2 = _interopRequireDefault(_publishAnalytics);
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _formatSEOData = require('../../utils/formatSEOData');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);
var _services = require('../../services');
var _outlineNavigationItems = require('./helpers/outlineNavigationItems');
var _checkUserIsAllowedToEditProperty = require('../../utils/checkUserIsAllowedToEditProperty');var _checkUserIsAllowedToEditProperty2 = _interopRequireDefault(_checkUserIsAllowedToEditProperty);
var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _checkUserIsAllowedToPublish = require('../../utils/checkUserIsAllowedToPublish');


var _PublishPropertyPage = require('./PublishPropertyPage.scss');var styles = _interopRequireWildcard(_PublishPropertyPage);
var _WhatsAppWidget = require('../../components/WhatsAppWidget/WhatsAppWidget');var _WhatsAppWidget2 = _interopRequireDefault(_WhatsAppWidget);
var _OutlineNavigation = require('../../containers/PublishForm/OutlineNavigation/OutlineNavigation');var _OutlineNavigation2 = _interopRequireDefault(_OutlineNavigation);
var _assetsToDelete = require('../../redux/modules/assetsToDelete');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
// Styles
var PublishPropertyPage = exports.PublishPropertyPage = function (_Component) {_inherits(PublishPropertyPage, _Component);
  function PublishPropertyPage(props) {_classCallCheck(this, PublishPropertyPage);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.



















































































































































































































    compareAndSaveUserDataToStorage = function (newUserData, oldUserData) {
      if (newUserData && oldUserData && !(0, _isEqual2.default)(newUserData, oldUserData)) {
        _constants.storage.value.setItem('userData', JSON.stringify(newUserData));
      } else if (newUserData !== null && oldUserData == null) {
        (0, _analyticsManager.setData)({ userId: newUserData.id });
        (0, _analyticsManager.setData)({ dimension1: newUserData.is_agent ? 'realtor' : 'regular' });
      }
    };_this.

    changeAssetsTags = function () {
      _this.props.changeAssetsTags();
    };_this.
    closeFormModal = function () {
      _this.setState({ isContactModalOpen: false });
      _this.redirectTo('/');
    };_this.

    handleShareClick = function () {
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.share, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.publish);
      _this.props.hideMessageModal();
    };_this.

    propertyPublishedSuccess = function (propertyData) {
      // ga event
      var isAgent = (0, _get2.default)(_this.props, 'userAuthentication.data.is_agent');
      var publishedBy = isAgent ? _analyticsConstants.eventLabel.agentPublish : _analyticsConstants.eventLabel.userPublish;
      (0, _publishAnalytics2.default)(publishedBy, 'published', _this.props);
      (0, _analyticsManager.trackGTM)({ name: _analyticsConstants.eventCategory.publishedProperty });
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.publish,
      _analyticsConstants.eventAction.publish, publishedBy);var _this$props =

      _this.props,locale = _this$props.locale,rootTranslate = _this$props.rootTranslate;var _ref =
      propertyData || {},id = _ref.id,isActive = _ref.isActive,thumbnail = _ref.thumbnail,propertyType = _ref.property_type;
      var localisedPropertyType = _this.props.rootTranslate('propertyTypes', propertyType);

      var sharingClearedUrl = (0, _makeSharingUrl2.default)('/home_details/' + id, locale);
      var protocol = sharingClearedUrl.includes('://') ? '' : 'https://';
      var sharingUrl = '' + protocol + sharingClearedUrl;

      var sharingTitle = (0, _formatSEOData.formatPropertyTitle)(
      propertyData,
      localisedPropertyType,
      rootTranslate('propertyDetails'),
      locale);


      var agentWithPayments = !(0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties.allowed_until') && isAgent;
      var publisherWithPayments = !isAgent && !!(0, _get2.default)(_this.props, 'paidProducts.length');

      var sharingPropertyData = { propertyId: id, isActive: isActive, sharingUrl: sharingUrl, sharingTitle: sharingTitle, thumbnail: thumbnail };
      if (_this.props.routeData.location === 'publish' || _this.props.routeData.location === 'foreign_publish') {
        if (_this.props.routeData.location === 'publish' && !isAgent) {
          _this.props.openMessageModal({
            message:
            _react2.default.createElement(_components.RealtorPublishContactCompany, {
              propertyData: propertyData,
              contactAgencyOnPropertyCreation: _this.props.contactAgencyOnPropertyCreation,
              translate: _this.props.parsTranslate('RealtorPublishContactCompany'),
              hideMessageModal: _this.props.hideMessageModal,
              userAuthentication: _this.props.userAuthentication,
              locale: _this.props.locale,
              handleShareClick: _this.handleShareClick,
              sharingPropertyData: sharingPropertyData,
              companyData: _this.props.companyFindByNeighborhood.data }),


            className: !!_this.props.companyFindByNeighborhood.data ?
            'publishContactCompanyModal' :
            'publishContactCompanyNoCompanyModal',
            isCloseButtonInvisible: true });

        } else {
          _this.props.openMessageModal({
            message:
            _react2.default.createElement(_components.RealtorPublishAndPaySuccessful, {
              translate: _this.props.parsTranslate('SuccessModal'),
              hideMessageModal: _this.props.hideMessageModal,
              locale: _this.props.locale,
              withPayments: agentWithPayments || publisherWithPayments,
              shareData: {
                sharingData: sharingPropertyData,
                title: _this.props.parsTranslate('SuccessModal', 'share').toString(),
                handleClick: _this.handleShareClick } }),



            className: 'successPaymentModal',
            isCloseButtonInvisible: true });

        }
      } else {
        _this.props.openMessageModal({
          isCloseButtonInvisible: true,
          message:
          _react2.default.createElement('div', { className: 'contentMessage' },
            _react2.default.createElement('p', { className: styles.successPublishText },
              rootTranslate('publishProperty', 'publishSuccessfully'),
              _react2.default.createElement('br', null),
              rootTranslate('publishProperty', 'publishRecommendation')),


            _react2.default.createElement('div', { className: styles.buttonsLine },
              _react2.default.createElement(_components.ShareFacebookButton, {
                sharingData: sharingPropertyData,
                title: rootTranslate('propertyDetails', 'contacts', 'share').toString(),
                handleClick: _this.handleShareClick,
                className: styles.facebookShareProperty }),


              _react2.default.createElement('button', {
                  onClick: _this.props.hideMessageModal,
                  className: 'btn btn-default' },
                rootTranslate('publishProperty', 'ok')))) });





      }
    };_this.

    closeModalform = function () {
      _this.setState({ isOpenModalForm: false });
      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/foreign'));
    };_this.

    isEditPropertyPage = function () {return (
        _this.props.routeData.location === 'property' && _this.props.routeData.optionType === 'edit');};_this.

    isForeignPublishPage = function () {return _this.props.routeData.location === 'foreign_publish';};_this.

    isEditProject = function () {return _this.props.routeData.location === _constants.ENTITY_TYPES.PROJECT &&
      _this.props.routeData.optionType === 'edit';};_this.

    isEditForeignPropertyPage = function () {return (
        _this.props.routeData.location === 'foreign_property' && _this.props.routeData.optionType === 'edit');};_this.

    isUserShouldBeRedirected = function () {
      if (_this.isEditPropertyPage() || _this.isEditForeignPropertyPage()) {return false;}

      var userData = (0, _get2.default)(_this.props, 'userAuthentication.data') || {};
      var propertiesData = (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties');
      var isAgent = userData.is_agent;

      var isAllowedToPublishPage = (0, _checkUserIsAllowedToPublish.isUserAllowedToPublishPage)(userData, propertiesData);
      var isCanPublish = (0, _checkUserIsAllowedToPublish.isUserCanPublish)(propertiesData, isAgent);

      return !isAllowedToPublishPage || userData.access_token && !isCanPublish;
    };_this.

    isUserCanEditProperty = function () {var _this$props2 =
      _this.props,userAuthentication = _this$props2.userAuthentication,userProperties = _this$props2.userProperties;
      var userId = (0, _get2.default)(userAuthentication, 'data.id');
      var propertyId = _this.props.location.query.id;

      return (0, _checkUserIsAllowedToEditProperty2.default)(propertyId, userId, userProperties);
    };_this.

    prohibitEditing = function () {
      _this.props.clearUserPropertiesData();var
      userIsAuthorized = _this.props.userAuthentication.userIsAuthorized;
      var message = userIsAuthorized ? 'notAllowToEditProperty' : 'notAuthorizedToEditProperty';

      _this.props.openMessageModal({
        isCloseButtonInvisible: true,
        message:
        _react2.default.createElement('div', null,
          _react2.default.createElement('div', { className: styles.message }, _this.props.rootTranslate('publishProperty', message)),
          _react2.default.createElement('button', { onClick: _this.props.hideMessageModal, className: 'btn btn-primary' },
            _this.props.rootTranslate('publishProperty', 'ok'))) });




    };_this.

    publishTimeout = function () {var messageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'TIMEOUT';
      var message = void 0;
      switch (messageType) {
        case 'IMAGE_TIMEOUT':{
            message = _this.props.rootTranslate('publishProperty', 'imageTimeoutError');
            break;
          }
        case 'TIMEOUT':
        default:{
            message = _this.props.rootTranslate('publishProperty', 'timeoutError');
          }}


      _this.props.openMessageModal({
        isCloseButtonInvisible: true,
        message:
        _react2.default.createElement('div', null,
          _react2.default.createElement('div', { className: styles.message },
            message),


          _react2.default.createElement('button', { onClick: _this.props.hideMessageModal, className: 'btn btn-primary' },
            _this.props.rootTranslate('publishProperty', 'ok'))) });




    };_this.

    fixOutlineMenu = function () {
      if (_this.reportIssueButton && _this.outlineNavAnchor) {var
        offsetHeight = document.body.offsetHeight;
        var scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
        var scrollHeight = document.body.scrollHeight || 0;
        var footerHeight = 232;
        var bottomOffset = 86;
        var outlineAnchorBottomPosition = scrollTop + _this.outlineNavAnchor.offsetTop + _constants.desktopHeaderHeight;
        var scrollBottomPosition = scrollHeight - (footerHeight + bottomOffset);

        if (outlineAnchorBottomPosition >= scrollBottomPosition) {
          _this.outlineNav.style.position = 'absolute';
          _this.outlineNav.style.top = 'auto';
          _this.outlineNav.style.bottom = '86px';
        } else {
          _this.outlineNav.style.position = 'fixed';
          _this.outlineNav.style.top = '';
          _this.outlineNav.style.bottom = '';
        }

        if (_this.reportIssueAnchor.offsetTop <= scrollTop + offsetHeight) {
          _this.reportIssueButton.style.position = 'absolute';
        } else {
          _this.reportIssueButton.style.position = 'fixed';
        }
      }
    };_this.

    scrollReportIssueListener = function () {
      if (!_this.props.isMobile) {
        setTimeout(_this.fixOutlineMenu, 0);
      }
    };_this.

    redirectUser = function (isAgent) {return _this.redirectTo(isAgent ? '/contact_us_realtor' : '/');};_this.
    redirectForeignUser = function () {return _this.redirectTo('/foreign');};_this.
    redirectTo = function (path) {return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, path));};_this.
    changeNavigator = function (value) {return _this.setState({ isNavigator: value });};_this.
    changeAddProperty = function () {return _this.setState({ isAddProperty: true });};_this.

    renderReportIssueButton = function () {return (
        _react2.default.createElement('div', { className: styles.reportIssuesWrap, ref: function ref(_ref2) {_this.reportIssueButton = _ref2;} },
          _react2.default.createElement('div', {
              onClick: function onClick() {return _this.props.openReportIssueModal({
                  issueType: _constants.issueTypes.GENERAL,
                  reportType: _constants.reportTypes.PROPERTY });} },


            _this.props.rootTranslate('publishProperty', 'reportGeneralIssue'))));};_this.



    rendertitle = function () {var _this$props3 =
      _this.props,isMobile = _this$props3.isMobile,editedProperty = _this$props3.editedProperty,userAuthentication = _this$props3.userAuthentication;

      var userData = (0, _get2.default)(userAuthentication, 'data');
      var isAgent = (0, _get2.default)(userData, 'is_agent');
      var token = (0, _get2.default)(userData, 'access_token');
      var translate = _this.props.rootTranslate('publishProperty');

      var title = function title() {
        if (_this.state.isAddProperty) {
          return _react2.default.createElement('h1', null, translate('apartmentPlans'));
        } else if (editedProperty !== undefined) {
          return _react2.default.createElement('h1', null, translate('edit'));
        }

        return !isMobile && _react2.default.createElement('h1', null, translate('headTitle'));
      };

      return (
        _react2.default.createElement('div', { className: styles.formTitle },
          title(),

          _react2.default.createElement('p', null, translate('headDescription')),

          token && isAgent &&
          _react2.default.createElement('p', { className: styles.agentDescription }, translate('agentDescription'))));



    };_this.
    renderContactFormModal = function () {return (
        _react2.default.createElement(_components.Modal, {
            className: 'publishFormContactUsModal',
            isOpen: _this.state.isContactModalOpen,
            onRequestClose: _this.closeFormModal,
            translate: _this.props.rootTranslate,
            isRtl: _this.props.isRtl,
            withoutTitle: true },

          _react2.default.createElement(_RealtorLandingPublishFormModal2.default, {
            inModal: true,
            formModalIsOpen: _this.state.isContactModalOpen,
            handleRequest: _this.closeFormModal })));};_this.state = { outlineNavigationItems: (0, _outlineNavigationItems.getAllNavigationItems)(props.rootTranslate('publishProperty')), isNavigator: true, isOpenModalForm: false, isAddProperty: false, isContactModalOpen: false };return _this;}PublishPropertyPage.prototype.componentWillMount = function componentWillMount() {var foreignPropertiesActive = (0, _get2.default)(this.props, 'userAuthentication.data.foreignProperties.active', null);var foreignPropertiesAllowed = (0, _get2.default)(this.props, 'userAuthentication.data.foreignProperties.allowed', null);var isOnForeignPublishPage = this.props.routeData.location === 'foreign_publish';var allowedForeignCount = (0, _get2.default)(this.props, 'userProperties.data.meta.user_foreign_properties.allowed', null);var activeForeignCount = (0, _get2.default)(this.props, 'userProperties.data.meta.user_foreign_properties.active', null);var isPublishPermissionsForeign = (0, _get2.default)(this.props, 'userAuthentication.data.publish_permissions.foreign', null);var isRegularPublish = this.props.routeData.location === 'publish';var foreignPropertiesWithinLimit = allowedForeignCount <= activeForeignCount;var foreignPropertiesLimitReached = !allowedForeignCount && isOnForeignPublishPage && !(foreignPropertiesActive < foreignPropertiesAllowed);var hasPackage = (0, _get2.default)(this.props, 'userAuthentication.data.properties.allowed_until');var isAgent = (0, _get2.default)(this.props, 'userAuthentication.data.is_agent');if (!this.isEditPropertyPage()) {_services.MouseFlowService.initialize().then(_services.MouseFlowService.startRecording);}if (isRegularPublish && (this.isUserShouldBeRedirected() || isRegularPublish && !hasPackage && isAgent)) {if (isAgent) {this.setState({ isContactModalOpen: true });} else {this.redirectUser(isAgent);}}if (isOnForeignPublishPage && !isPublishPermissionsForeign && _reactRouter.browserHistory) {this.redirectForeignUser();}if (isOnForeignPublishPage && (foreignPropertiesLimitReached || foreignPropertiesWithinLimit)) {this.setState({ isOpenModalForm: true });}};PublishPropertyPage.prototype.componentDidMount = function componentDidMount() {if (global && global.window && !this.props.isMobile) {window.addEventListener('scroll', this.scrollReportIssueListener);}if (this.isEditPropertyPage() && !this.isUserCanEditProperty()) {this.prohibitEditing();}};PublishPropertyPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {var publishProperty = _ref3.publishProperty,userProperties = _ref3.userProperties,messageModal = _ref3.messageModal,userAuthentication = _ref3.userAuthentication,route = _ref3.route,location = _ref3.routeData.location,locale = _ref3.locale,rootTranslate = _ref3.rootTranslate;(0, _publishAnalytics2.default)(userAuthentication, 'userAuthentication', this.props);var isEditPropertyPage = this.isEditPropertyPage();var isForeignPublishPage = this.isForeignPublishPage();var isEditForeignPropertyPage = this.isEditForeignPropertyPage();if (location !== this.props.routeData.location) {var foreignPropertiesActive = (0, _get2.default)(userAuthentication, 'data.foreignProperties.active', null);var foreignPropertiesAllowed = (0, _get2.default)(userAuthentication, 'data.foreignProperties.allowed', null);var isOnForeignPublishPage = location === 'foreign_publish';var allowedForeignCount = (0, _get2.default)(userProperties, 'data.meta.user_foreign_properties.allowed', null);var activeForeignCount = (0, _get2.default)(userProperties, 'data.meta.user_foreign_properties.active', null);var foreignPropertiesWithinLimit = allowedForeignCount <= activeForeignCount;var foreignPropertiesLimitReached = !allowedForeignCount && isOnForeignPublishPage && !(foreignPropertiesActive < foreignPropertiesAllowed);if (isOnForeignPublishPage && (foreignPropertiesLimitReached || foreignPropertiesWithinLimit)) {this.setState({ isOpenModalForm: true });}}if ((0, _get2.default)(userAuthentication, 'data.access_token')) {// Check route change
      if (route !== this.props.route) {if (location === 'publish' && this.props.routeData.location === 'property') {global.location.reload();}}var publishError = this.props.rootTranslate('publishProperty', 'publishError');var propertyPublished = !this.props.publishProperty.published && publishProperty.published;var prevError = this.props.publishProperty.error;var newError = publishProperty.error;var errorChanged = prevError && newError && prevError.message !== newError.message;var newErrorName = newError && newError.name;var prevErrorName = prevError && prevError.name;var isQuotaViolation = newError && newError.name === 'QuotaViolationError' && newErrorName !== prevErrorName;if (propertyPublished) {this.propertyPublishedSuccess((0, _get2.default)(publishProperty, 'data.data'));} else if (errorChanged) {console.error(publishProperty.error.message);this.props.openMessageModal({ message: publishError });} else if (isQuotaViolation) {this.setState({ isOpenModalForm: true });} else if (!prevError && newError) {console.error(newError.message || newError);switch (newError.message) {case 'TIMEOUT':{this.publishTimeout('TIMEOUT');break;}default:{this.props.openMessageModal({ message: publishError });}}}if (userProperties.error && !this.props.userProperties.error) {console.error(userProperties.error.message);this.props.openMessageModal({ message: publishError });}if (userProperties.updated && !this.props.userProperties.updated) {this.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'contentMessage successMessage' }, _react2.default.createElement('p', null, this.props.rootTranslate('publishProperty', 'updatedSuccessfully'))) });} // Direct access and redirect if needed
      var oldUserPropertiesData = (0, _get2.default)(this.props, 'userAuthentication.data.properties');var newUserPropertiesData = (0, _get2.default)(userAuthentication, 'data.properties');if (!oldUserPropertiesData && newUserPropertiesData) {var isAgent = (0, _get2.default)(userAuthentication, 'data.is_agent');var canPublish = (0, _checkUserIsAllowedToPublish.isUserCanPublish)(newUserPropertiesData, isAgent);var isRegularPublish = location === 'publish';var hasPackage = (0, _get2.default)(userAuthentication, 'data.properties.allowed_until');var noPackageAndAgent = isRegularPublish && !hasPackage && isAgent;var isPublishDisabled = (!isEditPropertyPage || !isEditForeignPropertyPage) && !canPublish;if (isPublishDisabled || noPackageAndAgent) {if (isAgent) {this.setState({ isContactModalOpen: true });} else {this.redirectUser(isAgent);}} else if (location === 'publish' && !(0, _get2.default)(userAuthentication, 'data.publish_permissions.regular')) {this.redirectTo('/foreign_publish');}}this.compareAndSaveUserDataToStorage(userAuthentication.data, (0, _get2.default)(this.props.userAuthentication, 'data'));}var isUpdated = userProperties.updated && !this.props.userProperties.updated;var isPublished = publishProperty.published && !this.props.publishProperty.published;if (isUpdated || isPublished) {this.changeAssetsTags();}if (!messageModal.isMessageModalOpen && this.props.messageModal.isMessageModalOpen) {var userCanEditProperty = this.isUserCanEditProperty();if (userProperties.updated && !this.props.userProperties.updated || this.props.publishProperty.published) {this.redirectTo('/manage_properties');this.props.resetPaymentData();this.props.setPaginationStepForAgentManage(1);} else if ((isEditPropertyPage || isEditForeignPropertyPage) && userCanEditProperty && this.props.userProperties.updated) {this.props.clearUpdatedState();this.redirectTo('/manage_properties');} else if ((isEditPropertyPage || isEditForeignPropertyPage) && !userCanEditProperty) {this.redirectTo('/');}}if (locale !== this.props.locale) {this.setState({ outlineNavigationItems: (0, _outlineNavigationItems.getAllNavigationItems)(rootTranslate('publishProperty')) });}};PublishPropertyPage.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps, newState) {var publishComponentLocations = ['publish', 'property', 'foreign_publish', 'foreign_property'];var isPublishComponentLocations = publishComponentLocations.indexOf(newProps.routeData.location) !== -1;var isLocale = newProps.locale !== this.props.locale;var isAddProperty = newState.isAddProperty !== this.state.isAddProperty;return isPublishComponentLocations || isLocale || isAddProperty;};PublishPropertyPage.prototype.componentWillUnmount = function componentWillUnmount() {_services.MouseFlowService.stopRecording();if (global && global.window && !this.props.isMobile) {window.removeEventListener('scroll', this.scrollReportIssueListener);}this.props.resetForm();this.props.cleanAssets();};PublishPropertyPage.prototype.

  render = function render() {var _cx,_this2 = this;var _props =
    this.props,userAuthentication = _props.userAuthentication,location = _props.location,route = _props.route,isMobile = _props.isMobile,locale = _props.locale,isNative = _props.isNative;
    var isEditProject = this.isEditProject();
    var isEditProperty = this.isEditPropertyPage();
    var isForeignPublishPage = this.isForeignPublishPage();
    var isEditForeignPropertyPage = this.isEditForeignPropertyPage();
    var siteTitle = isEditProperty || isEditForeignPropertyPage ? 'editProperty' : 'publish';
    var multiLanguage = isEditProperty || isEditForeignPropertyPage ? [] : (0, _multiLanguageHeadTags2.default)(route, locale);

    var userData = (0, _get2.default)(userAuthentication, 'data');
    var isAgent = (0, _get2.default)(userData, 'is_agent');
    var token = (0, _get2.default)(userData, 'access_token');

    var hasPackage = token && (0, _get2.default)(userAuthentication, 'data.properties.allowed_until');

    var helmetTranslate = this.props.rootTranslate('helmet');
    var translate = this.props.rootTranslate('publishProperty');

    return (
      _react2.default.createElement('section', {
          className: (0, _classnames2.default)(styles.publishPage, (_cx = {}, _cx[
          styles.mobile] = isMobile, _cx[
          styles.native] = isNative, _cx)) },


        _react2.default.createElement('div', { className: styles.formTitleWrapper },
          !isMobile &&
          _react2.default.createElement('div', { className: styles.outlineOffset }),


          this.rendertitle()),


        _react2.default.createElement('div', { className: styles.container },
          _react2.default.createElement(_reactHelmet2.default, {
            titleTemplate: this.props.rootTranslate('title', 'titleTemplate')(),
            title: '' + this.props.rootTranslate('title', siteTitle),
            meta: [
            { property: 'og:url', content: '' + _constants.shareUrl + route },
            { property: 'og:title', content: helmetTranslate('publishTitle') + ' | \u202BOnMap' },
            { property: 'og:description', content: helmetTranslate('publishDescription') },
            { name: 'description', content: helmetTranslate('publishDescription') }],

            link: [].concat(
            multiLanguage, [
            { rel: 'canonical', href: '' + _constants.shareUrl + route }]) }),



          _react2.default.createElement('div', {
              id: 'containerElement',
              className: (0, _classnames2.default)(styles.publishPropertyForm, 'publish-property-page') },

            _react2.default.createElement('div', null,
              _react2.default.createElement(_containers.PublishForm, {
                isAddProperty: this.state.isAddProperty,
                translate: this.props.rootTranslate('publishProperty'),
                rootTranslate: this.props.rootTranslate,
                datePickerTranslates: this.props.rootTranslate('datePicker'),
                parsTranslate: this.props.parsTranslate,
                locale: this.props.locale,
                isMobile: this.props.isMobile,
                token: token,
                changeAddProperty: this.changeAddProperty,
                location: this.props.location,
                isRtl: this.props.isRtl,
                routeData: this.props.routeData,
                reportIssue: this.props.openReportIssueModal,
                changeNavigator: this.changeNavigator,
                calcReportButtonPosition: this.scrollReportIssueListener,
                uploadImageTimeout: function uploadImageTimeout() {return _this2.publishTimeout('IMAGE_TIMEOUT');},
                hasPackage: !!hasPackage,
                isForeign: isForeignPublishPage || isEditForeignPropertyPage,
                userProperties: this.props.userProperties }),

              this.props.isMobile && token && this.renderReportIssueButton())),



          !this.props.isMobile &&
          _react2.default.createElement('div', { className: styles.outlineNavigation },
            this.state.isNavigator && !isEditProject &&
            _react2.default.createElement('div', { className: styles.fixed, ref: function ref(_ref5) {_this2.outlineNav = _ref5;} },
              _react2.default.createElement(_OutlineNavigation2.default, {
                routeData: this.props.routeData,
                translate: this.props.rootTranslate('publishProperty'),
                navigationItems: this.state.outlineNavigationItems }),

              _react2.default.createElement('span', { ref: function ref(_ref4) {_this2.outlineNavAnchor = _ref4;} })),


            this.renderReportIssueButton())),



        _react2.default.createElement('div', { ref: function ref(_ref6) {_this2.reportIssueAnchor = _ref6;} }),
        _react2.default.createElement(_containers.ReportIssueModal, null),
        _react2.default.createElement(_ModalFeedbackIncreaseLimits2.default, {
          closeModal: this.closeModalform,
          openModal: this.state.isOpenModalForm,
          withoutSubtitle: true }),

        this.renderContactFormModal()));


  };return PublishPropertyPage;}(_react.Component);


PublishPropertyPage.propTypes = {
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  routeData: _propTypes2.default.object,
  route: _propTypes2.default.any.isRequired,
  parsTranslate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  publishProperty: _propTypes2.default.object,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  clearUserPropertiesData: _propTypes2.default.func,
  userAuthentication: _propTypes2.default.object,
  userProperties: _propTypes2.default.object,
  paidProducts: _propTypes2.default.array,
  messageModal: _propTypes2.default.object,
  location: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool,
  resetForm: _propTypes2.default.func,
  resetPaymentData: _propTypes2.default.func,
  changeAssetsTags: _propTypes2.default.func,
  cleanAssets: _propTypes2.default.func,
  openReportIssueModal: _propTypes2.default.func,
  authenticateUser: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  socialNetworkAuthentication: _propTypes2.default.func,
  setPaginationStepForAgentManage: _propTypes2.default.func,
  clearUpdatedState: _propTypes2.default.func,
  contactAgencyOnPropertyCreation: _propTypes2.default.func,
  editedProperty: _propTypes2.default.object,
  companyFindByNeighborhood: _propTypes2.default.object,
  isNative: _propTypes2.default.bool };


var asyncData = [{
  key: 'editProperty',
  promise: function promise(_ref7) {var _ref7$location = _ref7.location,pathname = _ref7$location.pathname,query = _ref7$location.query,_ref7$store = _ref7.store,getState = _ref7$store.getState,dispatch = _ref7$store.dispatch;
    var isEditPage = pathname.indexOf('property/edit') !== -1 ||
    pathname.indexOf('foreign_property/edit') !== -1;
    var isEditProject = pathname.indexOf('project/edit') !== -1;
    var state = getState();
    var accessToken = (0, _get2.default)(state, 'userAuthentication.accessToken') || (0, _get2.default)(state, 'userAuthentication.data.access_token');
    if (isEditPage && query.id && accessToken) {
      return dispatch((0, _manageProperties.loadPropertyById)({ id: query.id, my: true, token: accessToken }));
    }
    if (isEditProject && query.id && accessToken) {
      return dispatch((0, _manageProperties.loadProjectById)({ id: query.id }));
    }
    return null;
  } }];


var mapStateToProps = function mapStateToProps(_ref8) {var
  lang = _ref8.lang,
  publishProperty = _ref8.publishProperty,
  userAuthentication = _ref8.userAuthentication,
  manageProperties = _ref8.manageProperties,
  messageModal = _ref8.messageModal,
  native = _ref8.native,
  companyFindByNeighborhood = _ref8.companyFindByNeighborhood,
  payments = _ref8.payments;return (
    {
      rootTranslate: (0, _reduxPagan.getLang)(lang, 'static'),
      parsTranslate: (0, _reduxPagan.getLang)(lang, 'PublishProperty'),
      publishProperty: publishProperty,
      userAuthentication: userAuthentication,
      isNative: native.isNative,
      editedProperty: manageProperties.editedProperty,
      userProperties: manageProperties,
      paidProducts: payments.paidProducts,
      companyFindByNeighborhood: companyFindByNeighborhood,
      messageModal: messageModal });};


var mapDispatchToProps = {
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  clearUserPropertiesData: _manageProperties.clearUserPropertiesData,
  resetForm: _publishProperty.resetForm,
  changeAssetsTags: _assetsToDelete.changeAssetsTags,
  cleanAssets: _assetsToDelete.cleanAssets,
  openReportIssueModal: _reportIssues.openReportIssueModal,
  authenticateUser: _userAuthentication.authenticateUser,
  openAuthenticationModal: _userAuthentication.openAuthenticationModal,
  socialNetworkAuthentication: _userAuthentication.socialNetworkAuthentication,
  resetPaymentData: _payments.resetPaymentData,
  clearUpdatedState: _manageProperties.clearUpdatedState,
  setPaginationStepForAgentManage: _manageProperties.setCurrentPaginationStep,
  contactAgencyOnPropertyCreation: _contactAgencyOnPropertyCreation.contactAgencyOnPropertyCreation };exports.default =


(0, _ramda.compose)(
(0, _reduxConnect.asyncConnect)(asyncData),
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
PublishPropertyPage);


//////////////////
// WEBPACK FOOTER
// ./src/pages/PublishPropertyPage/PublishPropertyPage.js
// module id = 3034
// module chunks = 0